/* Copyright (c) 2024 Xperi. All Rights Reserved. */

import type { TivoPayloadAction } from '../../../core/tivo/tivo-redux-wrapper';
import {
    SET_HIDE_ADULT_CONTENT_SETTING_HIGHLIGHT_POSITION,
    SET_HIDE_ADULT_CONTENT_SETTING_VERTICAL_LIMIT,
    SET_HIDE_ADULT_CONTENT_STATE,
} from './hideadultcontent.types';

export const setHideAdultContentSettingVerticalLimitAction = (
    verticalLimit: number,
): TivoPayloadAction<{ verticalLimit: number }> => ({
    type: SET_HIDE_ADULT_CONTENT_SETTING_VERTICAL_LIMIT,
    payload: {
        verticalLimit,
    },
});

export const setHideAdultContentStateAction = (
    hideAdultContent: boolean,
): TivoPayloadAction<{ hideAdultContent: boolean }> => ({
    type: SET_HIDE_ADULT_CONTENT_STATE,
    payload: {
        hideAdultContent,
    },
});

export const setHideAdultContentSettingHighlightPositionAction = (
    verticalPosition: number,
    isFocused: boolean,
): TivoPayloadAction<{
    verticalPosition: number;
    isFocused: boolean;
}> => ({
    type: SET_HIDE_ADULT_CONTENT_SETTING_HIGHLIGHT_POSITION,
    payload: {
        verticalPosition,
        isFocused,
    },
});
